import { DialogContent, Dialog, DialogActions, Button } from "@mui/material";
import DialogTitle from "../components/02-organisms/DialogTitle";
import common from "@/i18n/definitions/common";
import auth from "../i18n/definitions/auth";
import { useIntl } from "react-intl";
import { ReactElement } from "react";

const LoginInfoDialog = ({
  linkToExternalLogInPage,
  onCancel
}: {
  linkToExternalLogInPage: string;
  onCancel: () => unknown;
}): ReactElement => {
  const { formatMessage } = useIntl();

  return (
    <Dialog
      open={true}
      aria-labelledby="simple-dialog-title"
      PaperProps={{ style: { overflowY: "visible" } }}>
      <DialogTitle id="customized-dialog-title" onClose={onCancel}>
        {formatMessage(auth.loginInfoDialogTitle)}
      </DialogTitle>
      <DialogContent style={{ overflowY: "visible" }}>
        <p className="mx-8 my-6">{formatMessage(auth.loginInfoDialogText)}</p>
      </DialogContent>
      <DialogActions>
        <div className="flex pr-6 pb-4">
          <div className="mr-4">
            <Button onClick={onCancel} color="primary" variant="outlined">
              {formatMessage(common.cancel)}
            </Button>
          </div>
          <Button
            onClick={() => {
              window.location.href = linkToExternalLogInPage;
            }}
            color="primary"
            variant="contained">
            {formatMessage(auth.jatkaKirjautumiseen)}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default LoginInfoDialog;
